var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\xA6\x86 icon \"search\""
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 10.5L13 13.5",
    stroke: "#777777",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1 6.64285C1 9.48317 3.30253 11.7857 6.14286 11.7857C7.56545 11.7857 8.85323 11.2081 9.78425 10.2746C10.7121 9.34431 11.2857 8.06057 11.2857 6.64285C11.2857 3.80253 8.98317 1.5 6.14286 1.5C3.30253 1.5 1 3.80253 1 6.64285Z",
    stroke: "#777777",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.2966dc5f7185a0534733ef62e506fcdf.svg";
export { ForwardRef as ReactComponent };